import {Action, Module, Mutation} from "vuex-module-decorators";
import store, {currentUserModule} from "@/store";
import BaseModule from "@/store/modules/BaseModule";
import {MdbsCore} from "@/api/tsclient";
import Rights = MdbsCore.Rights;
import NtdUserDto = MdbsCore.NtdUserDto;

const ntdUserClient = new MdbsCore.NtdUserClient();

@Module({namespaced: true, name: 'ntdUsers', store: store})
export default class NtdUsersModule extends BaseModule {

    private _ntdUsers: Array<NtdUserDto> = new Array<MdbsCore.NtdUserDto>();

    public get ntdUsers(): Array<NtdUserDto> {
        return this._ntdUsers;
    }

    @Mutation
    setNtdUsers(ntdUsers: Array<NtdUserDto>) {
        this._ntdUsers = ntdUsers;
    }

    @Mutation
    clearNtdUsers() {
        this.ntdUsers?.clear();
    }

    @Action({rawError: true})
    async isOnline() {
        return true; //TODO
    }

    @Action({rawError: true})
    async loadAll(includeDeleted?: boolean) {
        this.startLoading();
        this.clearNtdUsers();
        await this.execute(async () => {
            if(currentUserModule.hasRight(Rights.NtdInstituteGetAllCmd)){
                this.setNtdUsers(await ntdUserClient.getAllNtdUsers(includeDeleted));
            }
           else{
                this.clearNtdUsers();
            }
        });

        this.stopLoading();
    }
}